<template>
    <div>
        <pc-label
            v-if="label"
            v-bind:label="label"
            v-on:help-clicked="$emit('help-clicked')" />
        <div class="d-block d-print-none">
            <div class="input-group">
                <span class="d-flex align-items-center">
                    <pc-date
                        ref="input"
                        v-model="dateValue"
                        alt-label="label" />
                    <pc-input
                        v-model="timeValue"
                        type="time"
                        step="60"
                        alt-label="label" />
                </span>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, computed, toRefs, watch } from "vue";
    import pcLabel from "./pc-label.vue";
    import pcDate from "./pc-date.vue";
    import pcInput from "./pc-input.vue";

    const props = defineProps({
        label: {
            type: String,
            default: ""
        },
        modelValue: {
            type: String,
            default: ""
        }
    });

    const emit = defineEmits(["update:modelValue", "help-clicked"]);

    const { label, modelValue } = toRefs(props);

    // hacked to support en-US locale since this is only being used for FERC now (9/1/2024)
    function splitDateTime(dateTimeStr) {
        if (!dateTimeStr) {
            return { datePart: "", timePart: "" };
        }
        const date = new Date(dateTimeStr);
        const datePart = date.toLocaleDateString("en-US");
        const timePart = date.toLocaleTimeString("en-US", { hour12: false, minute: "2-digit", hour: "2-digit" });
        return { datePart, timePart };
    }

    const { datePart, timePart } = splitDateTime(modelValue.value);

    const dateValue = ref(datePart || "");
    const timeValue = ref(timePart || "");

    // Combine the date and time values into a single string
    const internalValue = computed(() => {
        const date = dateValue.value;
        const time = timeValue.value;
        // If both date and time are set, combine them, else return the one that is set
        return date && time ? `${date} ${time}` : date || time;
    });

    // Watch the internalValue and emit it to the parent component
    watch(internalValue, (newValue) => {
        emit("update:modelValue", newValue);
    });
</script>
